import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import { fetchCoach }       from "Actions/Admin/User/CoachActions";

// Sections
import StrechList           from "Components/Admin/Strech/Strech/StrechList";
import StudentList          from "Components/Coach/Student/StudentList";
import GroupList            from "Components/Admin/Strech/Group/GroupList";
import ConversationList     from "Components/Admin/Conversation/ConversationList";
import MeetingList          from "Components/Admin/Strech/Meeting/MeetingList";
import InvoiceList          from "Components/Admin/Coach/Invoice/InvoiceList";
import TicketList           from "Components/Admin/Ticket/Ticket/TicketList";

// Components
import CoachDetails         from "./CoachDetails";
import SecondaryNav         from "Components/Utils/Navigation/SecondaryNav";
import AdminRoute           from "Components/Utils/Route/AdminRoute";
import SwitchRoute          from "dashboard/dist/Components/SwitchRoute";
import NavigationItem       from "dashboard/dist/Components/NavigationItem";



/**
 * The Coach Page
 */
class CoachPage extends React.Component {
    /**
     * Load the Data
     * @returns {Void}
     */
    componentDidMount() {
        this.props.fetchCoach(this.props.params.coachID, true);
    }

    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        if (this.props.params.coachID !== prevProps.params.coachID) {
            this.props.fetchCoach(this.props.params.coachID, true);
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elem, from, params, match, route } = this.props;
        const { path, url                        } = match;

        return <>
            <SecondaryNav
                message={elem.credentialName}
                fallback="COACHES_SINGULAR"
                href={from}
                path={route}
                baseUrl={url}
            >
                <NavigationItem message="STRECHES_NAME"       url="STRECHES"      icon="strech"       />
                <NavigationItem message="STUDENTS_NAME"       url="STUDENTS"      icon="student"      />
                <NavigationItem message="GROUPS_NAME"         url="GROUPS"        icon="group"        />
                <NavigationItem message="CONVERSATIONS_NAME"  url="CONVERSATIONS" icon="conversation" />
                <NavigationItem message="MEETINGS_NAME"       url="MEETINGS"      icon="meeting"      />
                <NavigationItem message="COACH_INVOICES_NAME" url="INVOICES"      icon="invoice"      />
                <NavigationItem message="TICKETS_NAME"        url="TICKETS"       icon="ticket"       />
            </SecondaryNav>

            <SwitchRoute type="COACH" path={path} baseUrl={url} withDetails>
                <AdminRoute url="STRECHES"      component={StrechList}       />
                <AdminRoute url="STUDENTS"      component={StudentList}      />
                <AdminRoute url="GROUPS"        component={GroupList}        />
                <AdminRoute url="CONVERSATIONS" component={ConversationList} />
                <AdminRoute url="MEETINGS"      component={MeetingList}      />
                <AdminRoute url="INVOICES"      component={InvoiceList}      />
                <AdminRoute url="TICKETS"       component={TicketList}       />
            </SwitchRoute>

            <CoachDetails credentialID={params.coachID} />
        </>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchCoach : PropTypes.func.isRequired,
        elem       : PropTypes.object.isRequired,
        from       : PropTypes.string.isRequired,
        params     : PropTypes.object.isRequired,
        match      : PropTypes.object.isRequired,
        route      : PropTypes.string.isRequired,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            elem : state.coach.elem,
        };
    }
}

export default connect(CoachPage.mapStateToProps, {
    fetchCoach,
})(CoachPage);
